import { render, staticRenderFns } from "./ModalToSIMASN.vue?vue&type=template&id=05879012"
import script from "./ModalToSIMASN.vue?vue&type=script&lang=js"
export * from "./ModalToSIMASN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports